module.exports = __webpack_public_path__ + "static/media/loading.3388acbf.png";